import React, { useState, Fragment } from "react";
import { useQuery } from "@tanstack/react-query";

import StdButton from "components/Buttons/StdButton";
import mainStore from "store/mainStore";
import childStore from "store/childStore";
import proxy from "api/proxy";

function ProductCombo({ onClose }) {
  const [selected, setSelected] = useState([]);
  const { store, record, updateRecord, updateStore } = mainStore.getState();
  const { record: child } = childStore.getState();

  const prods_mix = child?.product?.["products_mix."]?.map((item) => item.id);

  const queryProductCombo = useQuery({
    queryKey: ["productCombo", prods_mix],
    queryFn: async () => {
      let prods = [];

      if (prods_mix) {
        const { data } = await proxy.search(
          "product.product-mix.option",
          [["id", "in", prods_mix]],
          ["unit", "list_price", "option.name"],
        );
        prods = data;
      }

      return prods;
    },
  });

  const handleSelect = (index) => {
    let selected_ = [...selected];
    if (selected_.includes(index)) {
      const idx = selected_.findIndex((t) => index == t);
      selected_.splice(idx, 1);
    } else {
      selected_.push(index);
    }
    setSelected(selected_);
  };

  const closeProductCombo = () => {
    const products = queryProductCombo.data.filter((option, index) => {
      return selected.includes(index);
    });
    const _activeRecord = { ...record };
    const lines = _activeRecord.lines;
    const _storeRecord = { ...store };
    if (!_storeRecord.lines) {
      _storeRecord.lines = new Map();
      _storeRecord.lines.set("create", new Map());
    }
    const to_create = _storeRecord.lines.get("create");
    const timeStamp = new Date();

    let sequence = -timeStamp.getTime();
    for (const p of products) {
      const rec = {
        id: sequence,
        quantity: 1,
        unit: p.unit,
        product: p["option."],
        unit_price: p.list_price ?? 0,
        base_price: p.list_price ?? 0,
        unit_price_w_tax: p.list_price ?? 0,
        amount_w_tax: p.list_price ?? 0,
        status_order: "draft",
      };
      const storeRec = {
        id: sequence,
        quantity: 1,
        unit: p.unit,
        product: p["option."].id,
        unit_price: p.list_price ?? 0,
        base_price: p.list_price ?? 0,
        status_order: "draft",
      };
      lines.set(sequence, rec);
      to_create.set(sequence, storeRec);
      sequence -= 1;
    }
    updateRecord(_activeRecord);
    updateStore(_storeRecord);
    onClose();
  };

  return (
    <div className="px-4 sm:px-6 lg:px-8 py-2 md:col-span-2">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 pt-2">
        {queryProductCombo.data?.map((product, index) => {
          return (
            <div
              className={
                "rounded-md  cursor-pointer shadow-sm hover:opacity-50 text-center py-8 " +
                (!selected.includes(index) ? "bg-orange-100" : "bg-orange-300")
              }
              key={product.id}
              onClick={() => {
                handleSelect(index);
              }}
              name={index}
            >
              <p key={product.id} className="pointer-events-none flex-wrap p-2">
                {product["option."].name}
              </p>
            </div>
          );
        })}
      </div>
      <div className="flex flex-row-reverse space-x-3 pt-3">
        <StdButton
          color={"blue"}
          onClick={closeProductCombo}
          name={"done"}
          content={"modal_form.button_accept"}
        />
      </div>
    </div>
  );
}

export default ProductCombo;
